// Wall-E palette
// 0=transparent, 1=sandy-rust body, 2=dark tread, 3=amber eye,
// 4=dark shadow, 5=teal solar, 6=eye highlight
export const WALLE_PALETTE = {
  0: 'none',
  1: '#a07840',
  2: '#1c1c1c',
  3: '#f5c220',
  4: '#4a2e0e',
  5: '#00ccaa',
  6: '#ddd8a0',
};

// Frame A — treads position 1
export const FRAME_A = [
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  [0,0,0,0,3,3,0,0,3,3,0,0,0,0,0,0],
  [0,0,0,3,3,6,3,3,3,6,3,0,0,0,0,0],
  [0,0,0,3,3,3,3,3,3,3,3,0,0,0,0,0],
  [0,0,0,0,1,1,0,0,1,1,0,0,0,0,0,0],
  [0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0],
  [0,0,1,1,4,1,5,5,5,1,4,1,1,0,0,0],
  [0,0,1,1,4,1,5,5,5,1,4,1,1,0,0,0],
  [0,0,1,1,4,1,1,1,1,1,4,1,1,0,0,0],
  [0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0],
  [0,2,2,2,2,2,2,2,2,2,2,2,2,2,0,0],
  [2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,0],
  [2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,0],
  [0,2,2,2,2,2,2,2,2,2,2,2,2,2,0,0],
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
];

// Frame B — treads shifted for roll animation
export const FRAME_B = [
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  [0,0,0,0,3,3,0,0,3,3,0,0,0,0,0,0],
  [0,0,0,3,3,6,3,3,3,6,3,0,0,0,0,0],
  [0,0,0,3,3,3,3,3,3,3,3,0,0,0,0,0],
  [0,0,0,0,1,1,0,0,1,1,0,0,0,0,0,0],
  [0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0],
  [0,0,1,1,4,1,5,5,5,1,4,1,1,0,0,0],
  [0,0,1,1,4,1,5,5,5,1,4,1,1,0,0,0],
  [0,0,1,1,4,1,1,1,1,1,4,1,1,0,0,0],
  [0,0,0,1,1,1,1,1,1,1,1,1,0,0,0,0],
  [2,2,2,2,2,2,2,2,2,2,2,2,2,2,0,0],
  [2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,0],
  [2,2,2,2,2,2,2,2,2,2,2,2,2,2,2,0],
  [2,2,2,2,2,2,2,2,2,2,2,2,2,2,0,0],
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
];
